import { StationDetail } from "@/model/StationDetail.ts";
import { ChargingTypeEnum } from "@/enum/ChargingTypeEnum.ts";
import { Id } from "@/dto/CommonDto.ts";

/**
 * 충전소 조회 - req
 */
export class ReadStationDetailReqDto extends Id {
    chargingType: ChargingTypeEnum;
}

/**
 * 충전소 조회 - res
 */
export class ReadStationDetailResDto extends StationDetail {}
